import { AttributeName, Score, TreatmentType } from "@keita/lanepatrol-sdk";

export enum ColorByType {
  Score = "Score",
  Treatment = "Treatment",
  Attribute = "Attribute",
}

export interface ColorByScore {
  type: ColorByType.Score;
  scoreKey: keyof Score;
}

export interface ColorByTreatment {
  type: ColorByType.Treatment;
  treatmentType: TreatmentType;
}

export interface ColorByAttribute {
  type: ColorByType.Attribute;
  attributeName: AttributeName;
}

export type ColorBy = ColorByScore | ColorByTreatment | ColorByAttribute;
